import { Component, HostListener, OnInit } from '@angular/core';
import { IDashboardMidwifeResponse, IDashboardMumResponse } from 'src/app/models/dashboard.models';
import { AuthService } from 'src/app/services/auth.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { userType } from '../../../app/constants/global-constants';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})

export class DashboardComponent implements OnInit {

  userType = userType;
  dashboardMidwife: IDashboardMidwifeResponse;
  dashboardMum: IDashboardMumResponse;
  offset: number = 0;
  limit: number = 10;
  loading: boolean;
  width: number;

  constructor(public authService: AuthService,
              public dashboardService: DashboardService) { }

  ngOnInit(): void {
    this.width = window.innerWidth;
    this.getDashboard();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.width = window.innerWidth;
  }

  getDashboard(){
    let body:any = null;
    this.loading = true;
    if(this.authService.user?.userType==this.userType.MIDWIFE){
      body = {
        limit: this.limit,
        offset: this.offset
      }
      this.dashboardService.getDashboardMidwife(body).subscribe((res: IDashboardMidwifeResponse)=>{
        this.dashboardMidwife = res;
        this.authService.storeMidwifeId(res.payload.midwifeId);
        this.authService.setUserName(res.payload.name);
        console.log("Dashboard Midwife:", this.dashboardMidwife);
        this.loading = false;
      },err=>{
        console.error(err);
      });
    }
    else if(this.authService.user?.userType==this.userType.MUM)
    {
      this.dashboardService.getDashboardMum(body).subscribe((res: IDashboardMumResponse)=>{
        this.dashboardMum = res;
        this.authService.storeMumId(res.payload.mumId);
        this.authService.setUserName(res.payload.name);
        console.log("Dashboard Mum:", this.dashboardMum);
        this.loading = false;
      },err=>{
        console.error(err);
      });
    }
    else
    {
      console.error('Invalid User Type !');
    }
  }
}
